import { useAuth } from 'context/AuthProvider.js';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const URI = ApiEndpoint + 'operations/';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import NotificationAlert from 'componentes/generic/Notification.js';
import { useForm } from 'react-hook-form';
import { httpClient } from 'helpers/HttpClient.js';
import { Card, Col, Form, Row } from 'react-bootstrap';

import ExpedienteData from './_ExpedienteData.js';
import ConsumidorData from './_ConsumidorData.js';
import ProductoData from './_ProductoData.js';
import QuejaData from './_QuejaData.js';
import ExtraData from './_ExtraData.js';
import FalconCardHeader from 'componentes/common/FalconCardHeader.js';

const AddQueja = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [errorMesagge, setErrorMesagge] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [queja, setQueja] = useState(false);
  const [isError, setIsError] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue
  } = useForm({
    defaultValues: {
      fecharecepcion: new Date(),
      fechaqueja: new Date(),
      montopagado: 0,
      montoreal: 0,
      statusFacturacion: 11
    }
  });

  const onSubmitData = data => {
    console.log(data);

    setQueja({ ...queja, ...data });

    let newQueja = {
      recepcionQueja: {
        numeroqueja: data.expediente.replace('_', ''),
        fecharecepcionjmm: data.fecharecepcion,
        fechaqueja: data.fechaqueja,
        iddeterminante: data.determinante,
        iddelegacion: data.delegacion,
        idtipoproducto: data.tipoproducto,
        idclasificacionqueja: data.clasificacionQueja,
        nombreconsumidor: data.nombre,
        idstatusgenero: data.genero,
        lada: '',
        tel1: data.telefono,
        tel2: data.telefono2,
        motivoqueja: data.descripcionqueja,
        idstatusfacturacion: data.statusFacturacion,
        idstatus: 12,
        idclienteresponsable: data.cliente,
        montopagado: data.montopagado,
        montoreal: data.montoreal,
        tipoplataforma: data.tipoPlataforma,
        formatoqueja: data.formatoqueja,
        anio: data.anio,
        numeropedido: data.numeropedido,
        idtipoevento: data.idtipoevento
      },
      quejaDetalle: {
        descripcionwm: data.descripcionwalmart,
        oportunidad: data.oportunidad,
        fechaoportunidad: data.fechaoportunidad,
        expedientepil: data.expedientepil
      },
      seguimiento: {
        fecha: data.fechaaudiencia,
        espresencial: data.espresencial
      }
    };
    console.log(newQueja);

    // setStep(step + 1);
    httpClient('POST', URI + 'createqueja', newQueja, userData.token)
      .then(function (response) {
        console.log(response.data);
        if (!response.data.error) {
          //Notify
          setIsError(false);
          setErrorMesagge('Queja creada exitosamente');
          setShowErrorMessage(true);
          let path = `/`;
          window.location.href = path;
        } else {
          setIsError(true);
          setErrorMesagge('Ha Ocurrido un error');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        setIsError(true);
        setErrorMesagge('Ha Ocurrido un error');
        setShowErrorMessage(true);
        console.log(error);
      })
      .finally(() => {});
  };
  const onError = error => {
    console.log(error);
  };

  return (
    <>
      <Card
        as={Form}
        noValidate
        onSubmit={handleSubmit(onSubmitData, onError)}
        className="theme-wizard mb-5"
      >
        <Card.Body className="h-100">
          <Row>
            <Col>
              <Card>
                <FalconCardHeader
                  title="Expediente"
                  titleTag="h6"
                  className="border-200 border-bottom py-2"
                />
                <Card.Body>
                  <ExpedienteData
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <FalconCardHeader
                  title="Queja"
                  titleTag="h6"
                  className="border-200 border-bottom py-2"
                />
                <Card.Body>
                  <QuejaData
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <Card>
                <FalconCardHeader
                  title="Producto"
                  titleTag="h6"
                  className="border-200 border-bottom py-2"
                />
                <Card.Body>
                  <ProductoData
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <FalconCardHeader
                  title="Consumidor"
                  titleTag="h6"
                  className="border-200 border-bottom py-2"
                />
                <Card.Body>
                  <ConsumidorData
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <Card>
                <FalconCardHeader
                  title="Informacion Adicional"
                  titleTag="h6"
                  className="border-200 border-bottom py-2"
                />
                <Card.Body>
                  <ExtraData
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer></Card.Footer>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
        isError={isError}
      />
    </>
  );
};

AddQueja.propTypes = {
  variant: PropTypes.oneOf(['pills']),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool
};

export default AddQueja;
